/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ column: NonNullable<unknown> }} Admin_Analyze_Allocations_Sort_ByInputs */

const en_admin_analyze_allocations_sort_by = /** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sort by ${i?.column}`)
};

const de_admin_analyze_allocations_sort_by = /** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sortieren nach ${i?.column}`)
};

const es_admin_analyze_allocations_sort_by = /** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ordenar por ${i?.column}`)
};

const fr_admin_analyze_allocations_sort_by = /** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trier par ${i?.column}`)
};

const nl_admin_analyze_allocations_sort_by = /** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sorteren op ${i?.column}`)
};

/** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */
const it_admin_analyze_allocations_sort_by = en_admin_analyze_allocations_sort_by;

/** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_sort_by = en_admin_analyze_allocations_sort_by;

/** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */
const pl_admin_analyze_allocations_sort_by = en_admin_analyze_allocations_sort_by;

/** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */
const hu_admin_analyze_allocations_sort_by = en_admin_analyze_allocations_sort_by;

/** @type {(inputs: Admin_Analyze_Allocations_Sort_ByInputs) => LocalizedString} */
const ro_admin_analyze_allocations_sort_by = en_admin_analyze_allocations_sort_by;

/**
* | output |
* | --- |
* | "Sort by {column}" |
*
* @param {Admin_Analyze_Allocations_Sort_ByInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_sort_by = /** @type {((inputs: Admin_Analyze_Allocations_Sort_ByInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_Sort_ByInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_sort_by(inputs)
	if (locale === "de") return de_admin_analyze_allocations_sort_by(inputs)
	if (locale === "es") return es_admin_analyze_allocations_sort_by(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_sort_by(inputs)
	if (locale === "nl") return nl_admin_analyze_allocations_sort_by(inputs)
	if (locale === "it") return it_admin_analyze_allocations_sort_by(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_sort_by(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_sort_by(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_sort_by(inputs)
	return ro_admin_analyze_allocations_sort_by(inputs)
});
export { admin_analyze_allocations_sort_by as "admin.analyze.allocations.sort_by" }